import { Logo } from '@apparel/react/icons/Logo';

export { Logo };
export default Logo;
